import React from 'react';

import { Helmet } from 'react-helmet-async';

import {
  Environment,
} from 'common';

export const DEFAULT_SHARE_TITLE = 'WeTicket - Adventure awaits | Buy Tickets Online';
export const DEFAULT_SHARE_DESCRIPTION = 'Get your tickets to top events with WeTicket. Safe and secure online bookings.';

const getFallbackShareImage = () => `${Environment.uiHost.replace(/\/$/, '')}/favicon.png`;

export const toAbsoluteShareUrl = (url) => {
  if (!url) {
    return '';
  }

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  if (url.startsWith('http://') && !url.includes('localhost')) {
    return `https://${url.slice('http://'.length)}`;
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  const origin = typeof window !== 'undefined'
    ? window.location.origin
    : Environment.uiHost.replace(/\/$/, '');

  return `${origin}${url.startsWith('/') ? '' : '/'}${url}`;
};

export const getCanonicalShareUrl = (url) => {
  if (url) {
    return url;
  }

  if (typeof window === 'undefined') {
    return Environment.uiHost;
  }

  return `${window.location.origin}${window.location.pathname}`;
};

export const ShareMeta = ({
  title = DEFAULT_SHARE_TITLE,
  description = DEFAULT_SHARE_DESCRIPTION,
  url,
  image,
  imageWidth = '1200',
  imageHeight = '630',
  children,
}) => {
  const shareUrl = getCanonicalShareUrl(url);
  const shareImage = toAbsoluteShareUrl(image) || getFallbackShareImage();

  return (
    <Helmet prioritizeSeoTags={true}>
      <title>{title}</title>
      <link rel="canonical" href={shareUrl} />
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="WeTicket" />
      <meta property="og:locale" content="en_ZA" />
      <meta property="og:url" content={shareUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={shareImage} />
      <meta property="og:image:secure_url" content={shareImage} />
      <meta property="og:image:alt" content={title} />
      {image && <meta property="og:image:width" content={imageWidth} />}
      {image && <meta property="og:image:height" content={imageHeight} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={shareImage} />

      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description} />
      <meta itemProp="image" content={shareImage} />

      {children}
    </Helmet>
  );
};
